module.exports = __webpack_public_path__ + "img/catt.1cb69aaf.png";